import { render, staticRenderFns } from "./fengrengongzi.vue?vue&type=template&id=39b0cdc7&scoped=true&"
import script from "./fengrengongzi.vue?vue&type=script&lang=js&"
export * from "./fengrengongzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0cdc7",
  null
  
)

export default component.exports